import React from "react";
import {connect} from "react-redux";
import {get} from '../../utils/api';
import {setSeller, deleteSeller} from "../../actions/campaignActions";
import Loading from '../Shared/Loading';
import './sellers.css';

class Sellers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sellers: [],
            loading: true,
        };
        this.getSellers = this.getSellers.bind(this);
        this.inactiveSeller = this.inactiveSeller.bind(this);
        this.deleteSeller = this.deleteSeller.bind(this);
    }
    componentDidMount() {
        this.getSellers();
     };
     getSellers() {
        return get('manage/sellers')
            .then((res) => {
                this.setState({
                    sellers: res.result,
                    loading: false,
                })
            });
    }
    inactiveSeller(sid){
        const res = window.confirm('Are you sure you want to set this seller inactive?');
        if (res) {
            this.props.dispatch(setSeller(sid)).then(() => {
                this.getSellers();
            });
        }
    }
    deleteSeller(sid){
        const res = window.confirm('Are you sure you want to delete this seller?');
        if (res) {
            this.props.dispatch(deleteSeller(sid)).then(() => {
                this.getSellers();
            });;
        }
    }
    render(){
        return(
            <div className="">
                <h2>Sellers</h2>
                {this.state.loading ?  <Loading /> :
                <table className="seller-table" cellSpacing="0">
                <thead>
                </thead>
                <tbody>
                    {this.state.sellers.map((seller, k) => {
                        return(
                            <tr key={k}>
                                <td id="seller-name-col">{seller.name}</td>
                                <td>
                                    <button className="button button--grey inactive-btn"
                                    onClick={() => this.inactiveSeller(seller.id)}>Set Inactive
                                    </button>
                                </td>
                                <td>
                                    <button className="button button--red"
                                        onClick={() => this.deleteSeller(seller.id)}>Delete Seller
                                    </button>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
                </table>
                }
            </div>
        )
    }
}
export default  connect(null)(Sellers);